var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { show: _vm.move_start }, attrs: { id: "conduct" } },
    [
      _c("div", { staticClass: "conduct_main" }, [
        _c("div", { staticClass: "enlarge_main" }, [
          _c("div", { ref: "hitLine", staticClass: "Line" }),
          _c(
            "div",
            {
              ref: "enlarge",
              staticClass: "conduct_list",
              on: { transitionend: _vm.transitionend },
            },
            _vm._l(_vm.volutionList, function (item, index) {
              return _c(
                "div",
                {
                  key: "g" + index,
                  ref: "roll_item_" + index,
                  refInFor: true,
                  staticClass: "conduct_item",
                },
                [
                  item.gold
                    ? _c("div", { staticClass: "conduct_box gold" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/official/gold_icon.png"),
                            alt: "",
                          },
                        }),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "conduct_box",
                          class: [
                            "case_item_desc",
                            "case_item_level_gradientcut",
                            "rarity_" + item.rarity,
                          ],
                        },
                        [_c("img", { attrs: { src: item.itempic, alt: "" } })]
                      ),
                ]
              )
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "normal_main" }, [
          _c("div", { staticClass: "normal_box" }, [
            _c(
              "div",
              {
                ref: "normal",
                staticClass: "conduct_list",
                on: { transitionend: _vm.transitionend },
              },
              _vm._l(_vm.volutionList, function (item, index) {
                return _c("div", { key: index, staticClass: "conduct_item" }, [
                  item.gold
                    ? _c("div", { staticClass: "conduct_box gold" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/official/gold_icon.png"),
                            alt: "",
                          },
                        }),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "conduct_box",
                          class: [
                            "case_item_desc",
                            "case_item_level_gradientcut",
                            "rarity_" + item.rarity,
                          ],
                        },
                        [_c("img", { attrs: { src: item.itempic, alt: "" } })]
                      ),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }